import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Explore from '../blocks/Explore'
import { useNavigate } from 'react-router-dom'
import { DContext } from '../../context/DataContext'
import Loading from '../blocks/Loading'
import WhoWeAre from '../blocks/WhoAreWe'
import Landing from '../blocks/Landing/Landing'
import TourTypes from '../blocks/Landing/TourTypes'
import { FiArrowRight } from 'react-icons/fi'
import Logo from '../../assets/Logo.svg'
import MetaData from '../../utils/MetaData'
import TestimonialsBlock from '../blocks/TestimonialsBlock'

function Home() {

  const { t } = useTranslation()
  const { BeURL, ln } = useContext(DContext)
  const [popularPackages, setPopularPackages] = useState(null)

  const navPage = useNavigate()


  useEffect(() => {
    document.getElementById("container-element").scrollIntoView()

    fetch(`${BeURL}/fetch-popular-packages`)
      .then(res => res.json())
      .then(data => {
        console.log("Popular Packages:", data)
        if (data.success) {
          setPopularPackages(data.packages)
        }
        else {
          console.log(data.message)
        }
      })
      .catch(err => {
        console.log("Error in fetching popular packages:", err)
        alert("Trouble in connecting to the server! Please try again later.")
      })
  }, [BeURL])

  function convertToSlug(text) {
    return text
      .toLowerCase()          // Convert to lowercase
      .trim()                 // Remove leading and trailing spaces
      .replace(/\s+/g, '-')   // Replace spaces with hyphens
  }

  const resolveMediaSrc = (value) => {
    if (!value) {
      return ''
    }
    if (String(value).startsWith('http://') || String(value).startsWith('https://')) {
      return value
    }
    return `${BeURL}/${String(value).replace(/^\/+/, '')}`
  }



  if (!popularPackages) {
    return <Loading />
  }

  return (
    <>
      <MetaData
        title='Be Alright Krabi - Luxury Tours, Activities & Travel Guide in Krabi, Thailand'
        description='Discover premium tours and activities in Krabi, Thailand. Book island hopping, scuba diving, kayaking, sunset cruises, and private curated experiences with local experts.'
        keywords='Krabi tours, Krabi activities, Krabi island hopping, premium Krabi travel, Krabi scuba diving, Krabi kayaking, Thailand travel guide'
        canonicalUrl={`${window.location.origin}/`}
        ogTitle='Be Alright Krabi - Luxury Tours & Curated Experiences in Krabi'
        ogDescription='Explore world-class Krabi experiences with premium local curation, seamless booking, and trusted support.'
        ogType='website'
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'TravelAgency',
          name: 'Be Alright Krabi',
          url: window.location.origin,
          description: 'Discover premium tours and activities in Krabi, Thailand, from island hopping and scuba diving to private curated escapes.',
          areaServed: 'Krabi, Thailand'
        }}
        structuredDataId='homepage-structured-data'
      />
      <div className='w-full'>
        {/* Main content wrapper with semantic HTML for better SEO */}
        <main>
          <Landing />

          <TourTypes />

          {/* Popular Packages Section */}
          <section className='mx-auto my-12 w-[94%] max-w-6xl py-3' aria-labelledby='popular-tours-heading'>
            <div className='mobile-sticky-section-heading rounded-3xl bg-white/90 px-3 py-3 backdrop-blur-md sm:bg-transparent sm:px-0 sm:py-0 sm:backdrop-blur-0'>
              <h2 id='popular-tours-heading' className='text-center text-3xl font-black tracking-tight text-slate-900 sm:text-4xl'>{t("homepage.sections.popular.title")}</h2>
              <p className='mx-auto mt-2 max-w-2xl text-center text-sm text-slate-600 sm:text-base'>{t("homepage.sections.popular.desc")}</p>
            </div>

            <div className='mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3' role='list' aria-label='Popular tour packages'>
              {
                (popularPackages?.length > 0) ?
                  popularPackages.map((popular, i) => (
                    <article
                      className='group mobile-sticky-card package-card w-full max-w-[380px] bg-[rgba(255,255,255,0.84)] backdrop-blur-md'
                      key={i}
                      role='button'
                      onClick={() => window.location.href = `package/${convertToSlug(popular.title.en)}`}
                      itemScope
                      itemType='https://schema.org/TouristAttraction'
                      style={{ '--sticky-top': `${88 + (i * 12)}px` }}
                    >
                      <div className='relative overflow-hidden'>
                        <img
                          src={resolveMediaSrc(popular.images?.[0])}
                          className='package-card-img'
                          alt={`${popular.title.en} - Krabi tour package`}
                          itemProp='image'
                          loading='lazy'
                          onError={(e) => {
                            e.currentTarget.onerror = null
                            e.currentTarget.src = Logo
                            e.currentTarget.className = 'package-card-img object-contain bg-slate-100 p-6'
                          }}
                        />
                      </div>

                      <div className='p-4'>
                        <h3
                          className='card-title my-2 line-clamp-1 text-[#1739bd] font-medium'
                          itemProp='name'
                        >
                          {popular.title[ln]}
                        </h3>
                        <p
                          className='card-desc my-2 text-sm text-slate-600'
                          itemProp='description'
                        >
                          {popular.description[ln]}
                        </p>
                        <button className='sk-btn inline-flex items-center gap-2 whitespace-nowrap rounded-full' onClick={() => window.location.href = '/packages'} aria-label={`View more tours like ${popular.title.en}`}>
                          {t("packagePage.more")}
                          <FiArrowRight className='shrink-0 transition-transform duration-300 group-hover:translate-x-1' />
                        </button>
                      </div>
                    </article>
                  ))
                  :
                  <div className='col-span-full my-8 rounded-2xl border border-slate-200 bg-white p-8'>
                    <p className='mt-1 text-center text-base text-slate-600'>{t("homepage.sections.popular.noResult")}</p>
                  </div>
              }
            </div>

          </section>

          <Explore title={t("homepage.sections.destinations.title")} desc={t("homepage.sections.destinations.desc")} button={t("homepage.sections.destinations.button")} navPage={navPage} />


          <WhoWeAre />

          <TestimonialsBlock title={t('homepage.sections.testimonials.title')} subtitle={t('homepage.sections.testimonials.subtitle')} />

        </main>
      </div>
    </>
  )
}

export default Home
